module.exports = __webpack_public_path__ + "img/cover-papa.32f6abe4.png";